<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div id="digest_table">
                    <h3 v-html="infoObj.Title"></h3>
                    <a
                      @click="
                        pdf(
                          index,
                          infoObj.PDFFile_Size,
                          infoObj.PDFFileNameUrlGUID,
                          infoObj.IsOA
                        )
                      "
                      v-if="infoObj.PDFFile_Size > 0 && !infoObj.PDFisurl"
                      class="menthodsButss"
                    >
                      <i class="list_img down"></i>
                      PDF下载
                      <span class="">({{ infoObj.Read_Times }})</span>
                    </a>
                    <a
                      style="margin-left: 10px"
                      @click="annex(infoObj.AppendixGUID, infoObj.IsOA)"
                      v-if="infoObj.AppendixGUID != null"
                      class="menthodsBut"
                    >
                      <i class="list_img down"></i>
                      附录
                    </a>
                    <div class="copy_title">
                      <p
                        class="text"
                        style="
                          background: transparent;
                          border-style: none;
                          width: 100%;
                          height: auto;
                          overflow-y: hidden;
                          resize: none;
                          outline: none;
                        "
                        ref="texta"
                        v-html="infoObj.InCite"
                      ></p>

                      <span>
                        <el-button @click="copy" type="primary" size="mini"
                          >点击复制</el-button
                        >
                      </span>
                    </div>
                    <p class="ten detail_yjq">
                      <span>《{{ Itmtitle }}》</span>
                      <span>[ISSN:{{ ISSN }}/CN:{{ CN }}]</span>
                      <span class="advance_date" v-if="infoObj.Publish_Date"
                        >[预出版日期：{{
                          infoObj.Publish_Date.substring(
                            0,
                            infoObj.Publish_Date.lastIndexOf('T')
                          )
                        }}]</span
                      >
                    </p>
                    <table class="table ten">
                      <tbody>
                        <tr v-if="isEnzhaiy">
                          <th scope="row" align="left" class="pclist">
                            Title:
                          </th>

                          <td>
                            <p class="mobList">Title:</p>
                            <p v-html="infoObj.TitleE"></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">作者:</th>
                          <td>
                            <!-- <p v-html="infoObj.AuthorsHTML"></p> -->
                            <p class="mobList">作者：</p>
                            <p v-show="this.a != 1">
                              <a
                                href="javascript:;"
                                class="span"
                                v-for="(a, i) in text"
                                :key="i"
                                ><span @click="toSearch" v-html="a"></span
                                ><span v-if="i != text.length - 1"> ,</span></a
                              >
                            </p>
                            <p
                              v-show="this.a == 1"
                              v-html="infoObj.AuthorsHTML"
                            ></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">
                            Author(s):
                          </th>
                          <td>
                            <!-- <p><a v-html="infoObj.AuthorsHTMLE"></a></p> -->
                            <p class="mobList">Author(s):</p>
                            <p v-show="this.a != 1">
                              <a
                                href="javascript:;"
                                class="span"
                                v-for="(a, i) in actor"
                                :key="i"
                                ><span @click="toSearch" v-html="a"></span
                                ><span v-if="i != actor.length - 1"> ,</span></a
                              >
                            </p>
                            <p
                              v-show="this.a == 1"
                              v-html="infoObj.AuthorsHTMLE"
                            ></p>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" align="left" class="pclist">单位:</th>
                          <td>
                            <!-- <p><a v-html="infoObj.AuthorsHTMLE"></a></p> -->
                            <p class="mobList">单位:</p>
                            <p v-show="this.a != 1">
                              <a
                                href="javascript:;"
                                class="span"
                                v-for="(a, i) in Unit"
                                :key="i"
                                ><span @click="toSearch" v-html="a"></span
                                ><span v-if="i != Unit.length - 1"> ,</span></a
                              >
                            </p>
                            <p v-show="this.a == 1" v-html="infoObj.Unit"></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">Unit:</th>
                          <td>
                            <!-- <p><a v-html="infoObj.AuthorsHTMLE"></a></p> -->
                            <p class="mobList">Unit_EngLish:</p>
                            <p v-show="this.a != 1">
                              <a
                                href="javascript:;"
                                class="span"
                                v-for="(a, i) in Unit_EngLish"
                                :key="i"
                                ><span @click="toSearch" v-html="a"></span
                                ><span v-if="i != Unit_EngLish.length - 1">
                                  ,</span
                                ></a
                              >
                            </p>
                            <p
                              v-show="this.a == 1"
                              v-html="infoObj.Unit_EngLish"
                            ></p>
                          </td>
                        </tr>

                        <tr>
                          <th scope="row" align="left" class="pclist">
                            关键词:
                          </th>
                          <td>
                            <p class="mobList">关键词:</p>
                            <!-- <span id="LbKeyC"><a rel="external" v-html="infoObj.Keyword_Chinese"></a></span> -->
                            <p v-show="this.a != 1">
                              <a
                                href="javascript:;"
                                class="span"
                                v-for="(a, i) in key"
                                :key="i"
                                ><span @click="toSearch" v-html="a"></span
                                ><span v-if="i != key.length - 1"> ;</span></a
                              >
                            </p>
                            <p
                              v-show="this.a == 1"
                              v-html="infoObj.Keyword_Chinese"
                            ></p>
                            <!-- <p v-html="infoObj.Keyword_Chinese"></p> -->
                          </td>
                        </tr>
                        <tr v-if="isEnzhaiy">
                          <th scope="row" align="left" class="pclist">
                            Keywords:
                          </th>
                          <td>
                            <p class="mobList">Keywords:</p>
                            <!-- <span id="LbKeyE"><a rel="external" v-html="infoObj.Keywords_English"></a></span> -->
                            <p v-if="this.a != 1">
                              <a
                                href="javascript:;"
                                class="span"
                                v-for="(a, i) in keyEng"
                                :key="i"
                                ><span @click="toSearch" v-html="a"></span
                                ><span v-if="i != keyEng.length - 1">
                                  ;</span
                                ></a
                              >
                            </p>
                            <p
                              v-if="this.a == 1"
                              v-html="infoObj.Keywords_English"
                            ></p>
                            <!-- <p v-html="infoObj.Keywords_English"></p> -->
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">
                            分类号:
                          </th>
                          <td>
                            <p class="mobList">分类号:</p>
                            <p v-html="infoObj.ZTFLH"></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">DOI:</th>
                          <td>
                            <p class="mobList">DOI:</p>
                            <p>
                              <a
                                :href="'http://dx.doi.org/' + infoObj.DOI"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="doiurl"
                                ><span>{{ infoObj.DOI }}</span></a
                              >
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">
                            文献标识码:
                          </th>
                          <td>
                            <p class="mobList">文献标识码:</p>
                            <p v-html="infoObj.WXBSM"></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">摘要:</th>
                          <td>
                            <p class="mobList">摘要:</p>
                            <p v-html="infoObj.Abstract_Chinese"></p>
                          </td>
                        </tr>
                        <tr v-if="isEnzhaiy">
                          <th scope="row" align="left" class="pclist">
                            Abstract:
                          </th>
                          <td>
                            <p class="mobList">Abstract:</p>
                            <p v-html="infoObj.Abstract_English"></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">
                            参考文献<br />/References:
                          </th>
                          <td>
                            <p class="mobList">参考文献<br />/References:</p>
                            <p v-html="infoObj.Reference"></p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" align="left" class="pclist">
                            备注/Memo:
                          </th>
                          <td>
                            <p class="mobList">备注/Memo:</p>
                            <p v-html="infoObj.Memory"></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <Comment
                    :CommentList="CommentList"
                    :comm="comm"
                    v-if="isComment"
                    :Kind="kind"
                  ></Comment>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '../components/comment'
export default {
  data() {
    return {
      form: [],
      List: [],
      infoObj: [],
      comm: 0,
      CommentList: [],
      Token: '',
      commentText: '', // 评论内容
      TotalComments: 1000, // 评论总条数
      checked: false, // 是否匿名发表
      cc: '',
      NickyName: '',
      aa: '',
      previos: '',
      naxt: '',
      idnode: -1,
      issue: '',
      text: [],
      idnext: -1,
      bb: '',
      Title: '',
      newArr: [],
      actor: [],
      Unit: [],
      Unit_EngLish: [],
      key: [],
      Comments: '',
      keyEng: [],
      id: '',
      title: '',
      ida: '',
      indoe: '',
      inext: '',
      kind: 4,
      a: '',
      name: '',
      CanReview: false,
      isComment: false,
      isEnzhaiy: false,
      ISSN: '',
      CN: '',
      Itmtitle: '',
      path: '',
      setName: '',
      centerDialogVisible: false,
      codeId: 0,
    }
  },
  components: {
    Comment,
  },
  mounted() {
    var id = this.$route.query.ArticleID
    this.id = this.$route.query.ArticleID

    this._getPLLB(id)

    let params = [
      1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
      310, 12,
    ]
    this.$store
      .dispatch('_getSet', params)
      .then((res) => {
        this.SetItem = res.data.Data
        sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
        this.SetItem.map((item) => {
          if (item.SetItemID == 230) {
            item.Item_Value == '是'
              ? (this.isComment = true)
              : (this.isComment = false)
          }
          if (item.SetItemID == 6055) {
            item.Item_Value == '是'
              ? (this.isEnzhaiy = true)
              : (this.isEnzhaiy = false)
          }
          if (item.SetItemID == 5000) {
            this.ISSN = item.Item_Value
          }
          if (item.SetItemID == 5010) {
            this.CN = item.Item_Value
          }
          if (item.SetItemID == 1000) {
            this.Itmtitle = item.Item_Value
          }
          if (item.SetItemID == 6018) {
            if (item.Item_Value == '是') {
              if (this.$route.query.scriptID) {
                this.path = '_GetScriptPrePrintDetailed'
              } else {
                this.path = '_getLBXQ'
              }
            } else {
              if (this.$route.query.scriptID) {
                this.path = '_GetScriptPrePrintDetailed'
              } else {
                this.path = '_getLBXQ'
              }
            }
            this.getLBXQ()
          }
        })
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    onSubmit() {},
    _getPLLB(id) {
      var id = id
      let params = {
        Type: 2,
        ID: id,
        PageSize: 3,
      }
      var a = sessionStorage.getItem('aa')
      if (a == 1) {
        params.Type = 4
      } else {
        params.Type = 2
      }
      this.$store
        .dispatch('_getPLLB', params)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.CommentList = res.data.Data
            this.comm = res.data.ItemCount
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    pdf(i, size, guid, isoa) {
      let _this = this
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以下载')
          return
        } else {
          if (size <= 0) {
            ;('文件不存在')
            return
          }
        }
      } else {
        if (size <= 0) {
          alert('文件不存在')
          return
        }
      }
      this.$store.dispatch('_getPDFnew', { Id: guid }).then((Result) => {
        if (Result.data.IsSuccess === false) {
          this.$message.error(Result.data.Message)
        } else {
          var Ids = Result.request.responseURL.split('Id=')[1]
          window.location =
            Result.config.baseURL +
            '/api/Web/OpenArticleFilebyGuidNew?Id=' +
            Ids
        }
      })
    },
    annex(guid, isoa) {
      let _this = this
      if (!this.isdownb) {
        if (!isoa) {
          alert('只有登录用户才可以下载')
          return
        } else {
          if (guid == null) {
            ;('文件不存在')
            return
          }
        }
      } else {
        if (guid == null) {
          alert('文件不存在')
          return
        }
      }

      this.$store
        .dispatch('_OpenGUIDFile', {
          FileGUID: guid,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1)
          } else {
            this.$error(res.data.Message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getLBXQ() {
      var id = this.id
      var time = new Date().getTime()
      let params = {
        Id: id,
        sec: time,
      }
      this.$store
        .dispatch(this.path, params)
        .then((res) => {
          this.infoObj = res.data.Data
          this.CanReview = res.data.Data.CanReview
          this.Title = this.infoObj.Title
          this.id = this.infoObj.ArticleID
          var a = this.infoObj.IssueID
          sessionStorage.setItem('a', a)
          document.title = res.data.Data.Title
          if (res.data.Data.AuthorsHTML) {
            for (var num = 0; num < res.data.Data.AuthorsHTML.length; num++) {
              if (res.data.Data.AuthorsHTML.charAt(num) == ',') {
                if (res.data.Data.AuthorsHTML.charAt(num - 1) == '>') {
                  res.data.Data.AuthorsHTML = this.changeStr(
                    res.data.Data.AuthorsHTML,
                    num,
                    '#'
                  )
                }
              }
            }

            if (res.data.Data.AuthorsHTML.indexOf('#') != -1) {
              this.text = res.data.Data.AuthorsHTML.split('#')
            } else if (res.data.Data.AuthorsHTML.indexOf('、') != -1) {
              this.text = res.data.Data.AuthorsHTML.split('、')
            } else if (res.data.Data.AuthorsHTML.indexOf(';') != -1) {
              this.text = res.data.Data.AuthorsHTML.split(';')
            } else if (res.data.Data.AuthorsHTML.indexOf('；') != -1) {
              this.text = res.data.Data.AuthorsHTML.split('；')
            } else if (res.data.Data.AuthorsHTML.indexOf(' ;') != -1) {
              this.text = res.data.Data.AuthorsHTML.split(' ;')
            } else if (res.data.Data.AuthorsHTML.indexOf(',') != -1) {
              this.text = res.data.Data.AuthorsHTML.split(',')
            } else {
              this.text = res.data.Data.AuthorsHTML.split('，')
            }
          }

          if (res.data.Data.AuthorsHTMLE) {
            for (var num = 0; num < res.data.Data.AuthorsHTMLE.length; num++) {
              if (res.data.Data.AuthorsHTMLE.charAt(num) == ',') {
                if (res.data.Data.AuthorsHTMLE.charAt(num - 1) == '>') {
                  res.data.Data.AuthorsHTMLE = this.changeStr(
                    res.data.Data.AuthorsHTMLE,
                    num,
                    '#'
                  )
                }
              }
            }

            if (res.data.Data.AuthorsHTMLE) {
              if (res.data.Data.AuthorsHTMLE.indexOf('#') != -1) {
                this.actor = res.data.Data.AuthorsHTMLE.split('#')
              } else if (res.data.Data.AuthorsHTMLE.indexOf(', ') != -1) {
                this.actor = res.data.Data.AuthorsHTMLE.split(', ')
              } else if (res.data.Data.AuthorsHTMLE.indexOf('；') != -1) {
                this.actor = res.data.Data.AuthorsHTMLE.split('；')
              } else if (res.data.Data.AuthorsHTMLE.indexOf(';') != -1) {
                this.actor = res.data.Data.AuthorsHTMLE.split(';')
              } else if (res.data.Data.AuthorsHTMLE.indexOf('、') != -1) {
                this.actor = res.data.Data.AuthorsHTMLE.split('、')
              } else {
                this.actor = res.data.Data.AuthorsHTMLE.split('，')
              }
            }
          }

          if (res.data.Data.Unit) {
            if (res.data.Data.Unit.indexOf('#') != -1) {
              this.Unit = res.data.Data.Unit.split('#')
            } else if (res.data.Data.Unit.indexOf(', ') != -1) {
              this.Unit = res.data.Data.Unit.split(', ')
            } else if (res.data.Data.Unit.indexOf('；') != -1) {
              this.Unit = res.data.Data.Unit.split('；')
            } else if (res.data.Data.Unit.indexOf(';') != -1) {
              this.Unit = res.data.Data.Unit.split(';')
            } else if (res.data.Data.Unit.indexOf('、') != -1) {
              this.Unit = res.data.Data.Unit.split('、')
            } else {
              this.Unit = res.data.Data.Unit.split('，')
            }
          }
          if (res.data.Data.Unit_EngLish) {
            if (res.data.Data.Unit_EngLish.indexOf('#') != -1) {
              this.Unit_EngLish = res.data.Data.Unit_EngLish.split('#')
            } else if (res.data.Data.Unit_EngLish.indexOf(', ') != -1) {
              this.Unit_EngLish = res.data.Data.Unit_EngLish.split(', ')
            } else if (res.data.Data.Unit_EngLish.indexOf('；') != -1) {
              this.Unit_EngLish = res.data.Data.Unit_EngLish.split('；')
            } else if (res.data.Data.Unit_EngLish.indexOf(';') != -1) {
              this.Unit_EngLish = res.data.Data.Unit_EngLish.split(';')
            } else if (res.data.Data.Unit_EngLish.indexOf('、') != -1) {
              this.Unit_EngLish = res.data.Data.Unit_EngLish.split('、')
            } else {
              this.Unit_EngLish = res.data.Data.Unit_EngLish.split('，')
            }
          }

          if (res.data.Data.Keyword_Chinese) {
            res.data.Data.Keyword_Chinese =
              res.data.Data.Keyword_Chinese.replace(/<[^>]+>/g, '')
            if (res.data.Data.Keyword_Chinese.indexOf(',') != -1) {
              this.key = res.data.Data.Keyword_Chinese.split(',')
            } else if (res.data.Data.Keyword_Chinese.indexOf('、') != -1) {
              this.key = res.data.Data.Keyword_Chinese.split('、')
            } else if (res.data.Data.Keyword_Chinese.indexOf(';') != -1) {
              this.key = res.data.Data.Keyword_Chinese.split(';')
            } else if (res.data.Data.Keyword_Chinese.indexOf('；') != -1) {
              this.key = res.data.Data.Keyword_Chinese.split('；')
            } else if (res.data.Data.Keyword_Chinese.indexOf(' ;') != -1) {
              this.key = res.data.Data.Keyword_Chinese.split(' ;')
            } else {
              this.key = res.data.Data.Keyword_Chinese.split('，')
            }
          }
          if (res.data.Data.Keywords_English) {
            if (res.data.Data.Keywords_English.indexOf(',') != -1) {
              this.keyEng = res.data.Data.Keywords_English.split(',')
            } else if (res.data.Data.Keywords_English.indexOf('、') != -1) {
              this.keyEng = res.data.Data.Keywords_English.split('、')
            } else if (res.data.Data.Keywords_English.indexOf(';') != -1) {
              this.keyEng = res.data.Data.Keywords_English.split(';')
            } else if (res.data.Data.Keywords_English.indexOf('；') != -1) {
              this.keyEng = res.data.Data.Keywords_English.split('；')
            } else {
              this.keyEng = res.data.Data.Keywords_English.split('，')
            }
          }
          this.name = res.data.Data.AuthorsHTML
          this._getNewlist()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeStr(str, index, changeStr) {
      return (
        str.substr(0, index) + changeStr + str.substr(index + changeStr.length)
      )
    },
    copy() {
      var text = this.$refs.texta
      var Url2 = this.$refs.texta.innerText
      var oInput = document.createElement('input')
      oInput.value = Url2
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      alert('复制成功')
    },
    toSearch(e) {
      var put = e.target.innerText
      if (put.indexOf('1') != -1) {
        var a = put.split('1')[0]
        var b = a
        console.log(a)
      } else if (put.indexOf('2') != -1) {
        var a = put.split('2')[0]
        console.log(a)
        var b = a
      } else if (put.indexOf('3') != -1) {
        var a = put.split('3')[0]
        console.log(a)
      } else {
        var a = put
      }
      var b = a
      console.log(b)
      var name = e.target.className
      localStorage.setItem('value', b)
      if (b != '') {
        e.preventDefault()
        let routeUrl = this.$router.resolve({
          path: '/#/QuickSearch',
        })
        window.open(routeUrl.href, '_blank')
      }
    },
  },
}
</script>

<style scoped>
.text-top {
  vertical-align: text-top;
  padding-top: 0;
}
.menthodsButss:hover {
  color: rgb(108, 207, 9);
}
.list_img {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url('../assets/images/colum_arrow.png') no-repeat;
  position: relative;
  top: 3px;
}
.menthodsButss .down {
  background-position: 0px -16px;
}
.menthodsBut .down {
  background-position: 0px -16px;
}
.menthodsBut:hover {
  color: rgb(108, 207, 9);
}
</style>
